module.exports = "https://deal-img.imgix.net/consumer/modern/fallback.3a32e569.png";